import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

type HowElementsExplorerHeaderProps = {
  isExpanded: boolean;
  onToggleExpand: () => void;
};

export function HowElementsExplorerHeader({
  isExpanded,
  onToggleExpand,
}: HowElementsExplorerHeaderProps): ReactNode {
  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        gap: 2,
      }}
    >
      <Box sx={{ alignItems: 'center', display: 'flex', gap: 2.5 }}>
        <ButtonBase onClick={onToggleExpand} sx={{ color: 'primary.main' }}>
          {isExpanded ? (
            <KeyboardArrowUpIcon sx={{ height: 20, width: 20 }} />
          ) : (
            <KeyboardArrowDownIcon sx={{ height: 20, width: 20 }} />
          )}
        </ButtonBase>

        <Box>
          <Box
            sx={{
              alignItems: 'center',
              color: 'primary.main',
              display: 'flex',
              gap: 1,
            }}
          >
            <AutoAwesomeOutlinedIcon sx={{ color: 'primary.main' }} />
            <Typography
              sx={{
                color: 'text.primary',
                fontSize: 14,
                fontWeight: 700,
              }}
            >
              Learn How Elements Explorer Works
            </Typography>
          </Box>
          <Typography
            sx={{
              color: 'text.secondary',
              fontSize: 12,
              mt: 1,
            }}
          >
            Understanding elements through YOUR creatives
          </Typography>
        </Box>
      </Box>
      <ButtonBase onClick={onToggleExpand} sx={{ color: 'primary.main' }}>
        <Typography
          sx={{
            color: 'primary.main',
            fontSize: 12,
            fontWeight: 500,
          }}
        >
          {isExpanded ? 'Hide explanation' : 'Show explanation'}
        </Typography>
      </ButtonBase>
    </Box>
  );
}
